import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, TransitionGroup as _TransitionGroup, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "l-main"
}
const _hoisted_2 = { class: "sidebar" }
const _hoisted_3 = { class: "home" }
const _hoisted_4 = { class: "c-cu-alert-container" }
const _hoisted_5 = { class: "body" }
const _hoisted_6 = { class: "body__header" }
const _hoisted_7 = { class: "headline" }
const _hoisted_8 = { class: "body__header--title" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "body__main" }

import WidgetSidebar from "@/components/widget/WidgetSidebar.vue";
import WidgetHeader from "@/components/widget/WidgetHeader.vue";
import { useUserStore } from "@/features/users/user.store";
import { onMounted, onUnmounted, ref, watch } from "vue";
import { useNotificationStore } from "@/features/notification/notification.store";
import { useNotification } from "@/utils/notification";
import {
  AlertCircle,
  Building07,
  X,
  File06,
  MessageTextSquare02,
  Shield02,
} from "utruckin-icons";
import { getToken } from "@/utils/token";
import { useLiveStatsStore } from "@/features/live-stats/live-stats.store";
import router from "@/router";


export default /*@__PURE__*/_defineComponent({
  __name: 'MainLayout',
  setup(__props) {

const userStore = useUserStore();
const notificationStore = useNotificationStore();
const liveStatsStore = useLiveStatsStore();

const { pushNotification } = useNotification();

const loading = ref(true);
const notificationLoading = ref(false);
let intervalId: number;

const getList = async () => {
  if (notificationLoading.value) return;
  await notificationStore.getCount(notificationLoading, (data: any) => {
    notificationStore.notificationCount = data.count;
  });
};

const notifications = ref<any[]>([]);
let socket: WebSocket | null = null;
let liveStatsSocket: WebSocket | null = null;

const API_BASE_URL = process.env.VUE_APP_API_BASE_URL as string;

const deleteNotification = (id: string) => {
  notifications.value = notifications.value.filter((item) => item.id !== id);
};

const pushNot = (notification: any) => {
  if (notifications.value.length >= 3) {
    notifications.value.splice(0, 1);
  }

  notifications.value.push(notification);
};

const connectWebSocket = () => {
  const token = localStorage.getItem("access_token");
  if (!token) return;

  const wsUrl = `wss://api.board.eld.center/notifications/ws?token=${token}`;

  socket = new WebSocket(wsUrl);

  socket.onmessage = (event) => {
    const data = JSON.parse(event.data);

    pushNot(data.data);
  };

  socket.onerror = (error: any) => {
    const message = error instanceof Error ? error.message : String(error);
    pushNotification(message, "error");
  };

  socket.onclose = () => {
    setTimeout(() => {
      connectWebSocket();
    }, 5000);
  };
};

const connectLiveStatsWebSocket = () => {
  const token = localStorage.getItem("access_token");
  if (!token) return;

  const organizationId = localStorage.getItem("organizationId");

  if (!organizationId) router.push("/organization");

  liveStatsSocket = new WebSocket(
    `wss://api.board.eld.center/live-board-stats/ws?token=${token}&organization_id=${organizationId}`
  );

  liveStatsSocket.onmessage = (event) => {
    const data = JSON.parse(event.data);
    liveStatsStore.liveStatsData = data.data;
  };

  liveStatsSocket.onerror = (error: any) => {
    const message = error instanceof Error ? error.message : String(error);
    pushNotification(message, "error");
  };

  liveStatsSocket.onclose = () => {
    setTimeout(() => connectWebSocket(), 5000);
  };
};

const checkOrganizationId = () => {
  if (!localStorage.getItem("organizationId")) router.push("/organization");
};

watch(
  () => localStorage.getItem("organizationId"),
  () => {
    if (!localStorage.getItem("organizationId")) router.push("/organization");
  }
);

onMounted(() => {
  userStore.getUserProfile(loading);
  checkOrganizationId();
  getList();

  intervalId = window.setInterval(() => {
    getList();
  }, 60 * 1000);

  connectWebSocket();

  connectLiveStatsWebSocket();
});

onUnmounted(() => {
  clearInterval(intervalId);
  socket?.close();
  liveStatsSocket?.close();
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (!loading.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(WidgetSidebar)
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(WidgetHeader),
          _createVNode(_component_router_view)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_TransitionGroup, { name: "toast" }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(notifications.value, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item.id,
                  class: "c-cu-alert",
                  style: _normalizeStyle({
            bottom: `${index * 12}px`,
            right: '12px',
            zIndex: 100 + index,
          })
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["icon", item.type])
                  }, [
                    (item.type == 'task_assigned')
                      ? (_openBlock(), _createBlock(_unref(File06), {
                          key: 0,
                          size: 20
                        }))
                      : (item.type == 'qa_failed')
                        ? (_openBlock(), _createBlock(_unref(AlertCircle), {
                            key: 1,
                            size: 20
                          }))
                        : (item.type == 'task_comment_added')
                          ? (_openBlock(), _createBlock(_unref(MessageTextSquare02), {
                              key: 2,
                              size: 20
                            }))
                          : (item.type == 'company_created_without_team')
                            ? (_openBlock(), _createBlock(_unref(Building07), {
                                key: 3,
                                size: 20
                              }))
                            : (_openBlock(), _createBlock(_unref(Shield02), {
                                key: 4,
                                size: 20
                              }))
                  ], 2),
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, _toDisplayString(item.title), 1)
                      ]),
                      _createElementVNode("div", {
                        class: "body__header--time",
                        onClick: ($event: any) => (deleteNotification(item.id))
                      }, [
                        _createVNode(_unref(X), { size: 20 })
                      ], 8, _hoisted_9)
                    ]),
                    _createElementVNode("div", _hoisted_10, _toDisplayString(item.body), 1)
                  ])
                ], 4))
              }), 128))
            ]),
            _: 1
          })
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})